import React from 'react';
import PropTypes from 'prop-types';
import NewsletterSignup from '@homeaway/react-email-capture';
import ErrorBoundary from '../ErrorBoundary';
import './NewsletterSignupWidget.less';

const DEFAULT_LABELS = {
    emailForm: {
        heading: 'Get special offers, travel inspiration, and more from Vrbo',
        subheading: '',
        inputPlaceholder: 'Email address',
        buttonText: 'Sign up',
        errorMessage: 'Please enter a valid email address',
        legalNotice:
            'By continuing, you agree to our {termsAndConditions} and {privacyPolicy}. You can unsubscribe at any time.',
        privacyPolicy: 'Privacy Policy',
        termsAndConditions: 'Terms and Conditions',
    },
    emailSuccess: {
        heading: "You're all set!",
        subheading: null,
    },
    emailFail: {
        heading: 'Oops. Something went wrong.',
        subheading:
            'Sorry about that. If you like, we can give it another try.',
        buttonText: 'Try again',
        reportLink: 'Report a Problem',
    },
};

const mutateLabels = (props, defaults) => {
    defaults.emailForm = Object.assign({}, defaults.emailForm, props);
    return defaults;
};

const NewsletterSignupWidget = (props) => {
    const labels = mutateLabels(props, DEFAULT_LABELS);
    const apiRoutePath = `${props.homeRoute}/api/email-capture`;

    return (
        <ErrorBoundary>
            <section className="newsletter-signup-widget bg--color-bg-contrast">
                <NewsletterSignup
                    brandName="Vrbo"
                    labels={labels}
                    termsAndConditionsUrl="https://www.vrbo.com/legal/terms-and-conditions"
                    privacyPolicyUrl="https://www.vrbo.com/legal/privacy-policy"
                    pageName={`content-hub: ${
                        typeof window !== 'undefined'
                            ? window.location.pathname
                            : ''
                    }`}
                    pageType="content hub"
                    routePath={apiRoutePath}
                />
            </section>
        </ErrorBoundary>
    );
};

NewsletterSignupWidget.propTypes = {
    heading: PropTypes.string,
    subheading: PropTypes.string,
    buttonText: PropTypes.string,
};

export default NewsletterSignupWidget;
